// ============================================================
// MODAL (variant-added-modal)
// ============================================================
(function () {
  console.log('[ProofApprovalModal] Script loaded');

  let modalFormListenerAttached = false;

  function initProofApprovalModal() {
    console.log('[ProofApprovalModal] initProofApprovalModal called');

    const modal = document.getElementById('variant-added-modal');
    const checkoutBtn = modal ? modal.querySelector('[name="checkout"]') : null;
    const group = document.getElementById('proof-approval-modal');

    console.log('[ProofApprovalModal] checkoutBtn:', checkoutBtn);
    console.log('[ProofApprovalModal] group:', group);

    if (!checkoutBtn) return;

    checkoutBtn.removeAttribute('disabled');

    if (!group) {
      checkoutBtn.disabled = false;
      checkoutBtn.classList.remove('proof-approval-disabled');
      return;
    }

    const radios = group.querySelectorAll('input[name="proof_approval_modal"]');
    const errorMsg = document.getElementById('proof-approval-modal-error');

    const alreadySelected = group.querySelector('input[name="proof_approval_modal"]:checked');

    if (alreadySelected) {
      checkoutBtn.disabled = false;
      checkoutBtn.classList.remove('proof-approval-disabled');
    } else {
      checkoutBtn.disabled = true;
      checkoutBtn.classList.add('proof-approval-disabled');
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        console.log('[ProofApprovalModal] Radio changed:', radio.value);
        const liveBtn = modal ? modal.querySelector('[name="checkout"]') : null;
        if (liveBtn) {
          liveBtn.disabled = false;
          liveBtn.removeAttribute('disabled');
          liveBtn.classList.remove('proof-approval-disabled');
        }
        if (errorMsg) errorMsg.hidden = true;
      });
    });

    attachModalFormListener();
  }

  function attachModalFormListener() {
    if (modalFormListenerAttached) {
      console.log('[ProofApprovalModal] Form listener already attached, skipping');
      return;
    }

    const modal = document.getElementById('variant-added-modal');
    const cartForm = modal
      ? modal.querySelector('#cart_form')
      : document.getElementById('cart_form');

    console.log('[ProofApprovalModal] cartForm:', cartForm);
    if (!cartForm) return;

    modalFormListenerAttached = true;
    console.log('[ProofApprovalModal] Attaching submit listener to cart_form');

    cartForm.addEventListener('submit', function (e) {
      console.log('[ProofApprovalModal] Submit intercepted');

      const group = document.getElementById('proof-approval-modal');
      if (!group) return;

      const errorMsg = document.getElementById('proof-approval-modal-error');
      const selected = group.querySelector('input[name="proof_approval_modal"]:checked');
      console.log('[ProofApprovalModal] Selected:', selected ? selected.value : 'none');

      if (!selected) {
        e.preventDefault();
        if (errorMsg) errorMsg.hidden = false;
        group.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      e.preventDefault();

      const payload = {
        attributes: {
          'Proof Approval': selected.value === 'approve_proof'
            ? 'Send a proof before printing.'
            : 'No proof needed. I approve my design.'
        }
      };

      console.log('[ProofApprovalModal] Fetch payload:', JSON.stringify(payload));

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        console.log('[ProofApprovalModal] fetch succeeded:', res.status);
        return res.json();
      })
      .then(function (data) {
        console.log('[ProofApprovalModal] cart attributes:', JSON.stringify(data.attributes));
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.log('[ProofApprovalModal] fetch failed:', err);
        window.location.href = '/checkout';
      });
    });
  }

  // Watch modal slot for content replacement
  const modalSlot = document.querySelector('#variant-added-modal [slot="content"]');
  if (modalSlot) {
    new MutationObserver(function () {
      const section = document.getElementById('shopify-section-variant-added');
      if (section) {
        console.log('[ProofApprovalModal] Modal slot replaced, resetting form listener');
        modalFormListenerAttached = false;
        initProofApprovalModal();
      }
    }).observe(modalSlot, { childList: true });
  } else {
    const bodyObserver = new MutationObserver(function () {
      const slot = document.querySelector('#variant-added-modal [slot="content"]');
      if (slot) {
        bodyObserver.disconnect();
        console.log('[ProofApprovalModal] Modal slot found, switching to slot observer');
        modalFormListenerAttached = false;
        new MutationObserver(function () {
          const section = document.getElementById('shopify-section-variant-added');
          if (section) {
            console.log('[ProofApprovalModal] Modal slot replaced, resetting form listener');
            modalFormListenerAttached = false;
            initProofApprovalModal();
          }
        }).observe(slot, { childList: true });
        initProofApprovalModal();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.getElementById('shopify-section-variant-added')) {
    initProofApprovalModal();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      console.log('[ProofApprovalModal] Page restored from bfcache, re-initializing');
      modalFormListenerAttached = false;
      initProofApprovalModal();
    }
  });

})();


// ============================================================
// CART PAGE (#Cart form)
// ============================================================
(function () {
  console.log('[ProofApprovalCart] Script loaded');

  let cartFormListenerAttached = false;

  function initProofApprovalCart() {
    console.log('[ProofApprovalCart] initProofApprovalCart called');

    const checkoutBtn = document.querySelector('#Cart [name="checkout"]');
    const group = document.getElementById('proof-approval-cart');

    console.log('[ProofApprovalCart] checkoutBtn:', checkoutBtn);
    console.log('[ProofApprovalCart] group:', group);

    if (!checkoutBtn) return;

    checkoutBtn.removeAttribute('disabled');

    if (!group) {
      checkoutBtn.disabled = false;
      checkoutBtn.classList.remove('proof-approval-disabled');
      return;
    }

    const radios = group.querySelectorAll('input[name="proof_approval_cart"]');
    const errorMsg = document.getElementById('proof-approval-cart-error');

    // Restore saved selection from sessionStorage
    const savedSelection = sessionStorage.getItem('proofApprovalCartSelection');
    if (savedSelection) {
      const matchingRadio = group.querySelector('input[value="' + savedSelection + '"]');
      if (matchingRadio) {
        matchingRadio.checked = true;
        console.log('[ProofApprovalCart] Restored saved selection:', savedSelection);
      }
    }

    const alreadySelected = group.querySelector('input[name="proof_approval_cart"]:checked');

    if (alreadySelected) {
      checkoutBtn.disabled = false;
      checkoutBtn.classList.remove('proof-approval-disabled');
    } else {
      checkoutBtn.disabled = true;
      checkoutBtn.classList.add('proof-approval-disabled');
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        console.log('[ProofApprovalCart] Radio changed:', radio.value);
        sessionStorage.setItem('proofApprovalCartSelection', radio.value);
        const liveBtn = document.querySelector('#Cart [name="checkout"]');
        const liveError = document.getElementById('proof-approval-cart-error');
        if (liveBtn) {
          liveBtn.disabled = false;
          liveBtn.removeAttribute('disabled');
          liveBtn.classList.remove('proof-approval-disabled');
        }
        if (liveError) liveError.hidden = true;
      });
    });

    attachCartFormListener();
  }

  function attachCartFormListener() {
    if (cartFormListenerAttached) return;
    const cartForm = document.getElementById('Cart');
    if (!cartForm) return;

    cartFormListenerAttached = true;

    cartForm.addEventListener('submit', function (e) {
      console.log('[ProofApprovalCart] Submit intercepted');
      const group = document.getElementById('proof-approval-cart');
      if (!group) return;
      const errorMsg = document.getElementById('proof-approval-cart-error');
      const selected = group.querySelector('input[name="proof_approval_cart"]:checked');

      if (!selected) {
        e.preventDefault();
        if (errorMsg) errorMsg.hidden = false;
        group.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      e.preventDefault();

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Proof Approval': selected.value === 'approve_proof'
              ? 'Send a proof before printing.'
              : 'No proof needed. I approve my design.'
          }
        })
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        console.log('[ProofApprovalCart] cart attributes:', JSON.stringify(data.attributes));
        sessionStorage.removeItem('proofApprovalCartSelection');
        window.location.href = '/checkout';
      })
      .catch(function () {
        sessionStorage.removeItem('proofApprovalCartSelection');
        window.location.href = '/checkout';
      });
    });
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProofApprovalCart);
  } else {
    initProofApprovalCart();
  }

  // Poll every 500ms — catches Essence's History API cart updates
  // that bypass all standard navigation events
  setInterval(function () {
    const group = document.getElementById('proof-approval-cart');
    const btn = document.querySelector('#Cart [name="checkout"]');
    if (!group || !btn) return;

    const savedSelection = sessionStorage.getItem('proofApprovalCartSelection');
    if (savedSelection && btn.classList.contains('proof-approval-disabled')) {
      console.log('[ProofApprovalCart] Interval: detected disabled button with saved selection, re-init');
      cartFormListenerAttached = false;
      initProofApprovalCart();
    }
  }, 500);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      console.log('[ProofApprovalCart] Page restored from bfcache, re-initializing');
      cartFormListenerAttached = false;
      initProofApprovalCart();
    }
  });

})();